const documentLocale = document.documentElement.lang;
if (documentLocale === 'el') {
    document.querySelectorAll('h1').forEach((el) => {
        el.style.fontSize = '59px';
    });

    document.querySelectorAll('.sub-title').forEach((el) => {
        el.style.fontSize = '20px';
    });
}
